export const appPrimaryColor = '#00aa5b';
export const appSecondaryColor = '#145638';

export const expensesColor = '#DC143C';
export const incomeColor = '#2E8B57';
export const balanceColor = 'rgb(0, 0, 205)';
export const gradientStopBalanceColor = '#6e2c00';
export const taxColor = 'rgba(85, 70, 4, 1)';

export const tooltipBackgroundColor = 'rgba(255, 255, 255, 0.95)';
export const tooltipColor = '#333';
export const tooltipBorderColor = '#ccc';
export const tooltipBoxShadow = '0 2px 8px rgba(0,0,0,0.15)';
export const tooltipBorderBottomColor = '#e0e0e0';

export const tableDataRedColor = 'red';
export const tableDataGreenColor = '#00aa5b';
export const tableDataBlackColor = 'black';

export const scatterColor = '#0d6efd';

const expenseCategoryColors = [
  appPrimaryColor,
  appSecondaryColor,
  '#264653',
  '#2A9D8F',
  '#E76F51',
  '#457B9D',
  '#6A4C93',
  '#C44536',
  '#3A86FF',
  '#588157',
  '#DDA15E',
  '#8338EC',
];

export const getCategoryColor = (id: number) => {
  const colorIndex =
    ((id % expenseCategoryColors.length) + expenseCategoryColors.length) % expenseCategoryColors.length;
  return expenseCategoryColors[colorIndex];
};
